var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.cardClasses,staticStyle:{"width":"fit-content"}},[_c('v-card-text',{class:_vm.cardTextClasses},[_vm._v(" "+_vm._s(_vm.mensagemReferenciaConteudoTexto)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }